import api from './axios';

export const getAllCertificates = (params) => api.get('/certificates', { params });
export const downloadCertificate = (id) => api.get(`/certificates/${id}/download`, { responseType: 'blob' });
export const deliverCertificate = (id) => api.post(`/certificates/${id}/deliver`);
export const undoDeliverCertificate = (id) => api.delete(`/certificates/${id}/deliver`);

// Basim, teslimden AYRI bir adim: sertifikalar ozel kagida haftalik toplu
// basiliyor, teslim sonraki hafta tek tek yapiliyor.
export const markCertificatePrinted = (id) => api.post(`/certificates/${id}/printed`);
export const undoCertificatePrinted = (id) => api.delete(`/certificates/${id}/printed`);
